import { useState, useEffect, useContext } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { PipelineService, Pipeline, PipelineRequest } from "./pipeline.service";
import { LifecycleStage } from "../leads/lifecycle.service";
import CollapseHeader from "../../../core/common/collapse-header";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import male from "../../../../src/assets/male.png";
import axios from "axios";
import { API_BASE_URL } from "../../../environment";
import { getAuthHeaders } from "../../../utils/authUtils";
import { AuthContext } from "../../../context/authcontext";
import PipelineForm from "./pipelineForm";
import {
  usePipelineFormData,
  PipelineFormDataProvider,
} from "./pipelineFormDataContext";
import company from "../../../../src/assets/company.png";
import { formatCustomDateTime } from "../../../utils/dateUtils";
import { transformLookupPipelineToPipeline } from "../utils/lookupTransforms";
import {
  showSuccessAlert,
  showErrorAlert,
} from "../../uiInterface/base-ui/alertservice";
import { getLifecycleTypeName } from "../../../utils/lifecycleUtils";
import Activities from "../../../components/Tabs/Activities";
import Notes from "../../../components/Tabs/Notes";
import Files from "../../../components/Tabs/Files";
import Tasks from "../../../components/Tabs/Tasks";
import Email from "../../../components/Tabs/Email";
import ProductsServices from "../../../components/Tabs/ProductsServices";
import Chat from "../../../components/Tabs/Chat";
import Tabs from "../../../components/Tabs/tabs";
import { getStageColorByOrder } from "../../../utils/stageColors";
import { useEmailProviders } from "../../../hooks/useEmailProviders";
import ComposeEmail from "../../application/components/email/ComposeEmail";
import CustomFieldDisplay from "../../../components/CustomFieldDisplay";
import Tooltip from "@mui/material/Tooltip";
import MarkStatusModal from "../deals/MarkStatusModal";
import SalesActivityModal from "../salesActivity/SalesActivityModal";
import { getApiErrorMessage } from "../../../utils/apiErrorUtils";

interface PipelineDetailsContentProps {
  isEditPipelineOpen: boolean;
  setIsEditPipelineOpen: (value: boolean) => void;
}

const PipelineDetailsContent = ({ isEditPipelineOpen, setIsEditPipelineOpen }: PipelineDetailsContentProps) => {
  const route = all_routes;
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedTenantId, auth } = useContext(AuthContext);
  const { lifecycleStages: contextLifecycleStages } = usePipelineFormData();
  const [pipeline, setPipeline] = useState<Pipeline | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [lifecycleStages, setLifecycleStages] = useState<LifecycleStage[]>([]);
  const [stagesLoading, setStagesLoading] = useState(true);

  const [updatingStage, setUpdatingStage] = useState(false);
  const [updatingPriority, setUpdatingPriority] = useState(false);
  const [updateMessage, setUpdateMessage] = useState<string | null>(null);
  const [activitiesRefreshTrigger, setActivitiesRefreshTrigger] = useState(0);

  const [addcomment, setAddComment] = useState(false);
  const [stars, setStars] = useState<{ [key: number]: boolean }>({});
  const [openModal, setOpenModal] = useState(false);

  const [isUpdating, setIsUpdating] = useState(false);
  const [editError, setEditError] = useState<string>("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState<string>("");
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);

  const { hasConnectedProviders, loading: emailProvidersLoading } =
    useEmailProviders();
  const [isComposeEmailOpen, setIsComposeEmailOpen] = useState(false);
  const [composeOpenCounter, setComposeOpenCounter] = useState(0);

  const [showMarkStatusModal, setShowMarkStatusModal] = useState(false);
  const [showSalesActivityModal, setShowSalesActivityModal] = useState(false);

  const handleMarkStatusSuccess = async () => {
    if (!pipeline?.pipeline_id || !selectedTenantId) return;
    try {
      const refreshResponse = await PipelineService.getPipelineLookup(pipeline.pipeline_id, Number(selectedTenantId));
      setPipeline(transformLookupPipelineToPipeline(refreshResponse));
    } catch (error) {
      console.error("Failed to refresh pipeline after status mark", error);
    }
  };

  const togglecomment = () => {
    setAddComment((prevState) => !prevState);
  };

  const initializeStarsState = () => {
    const starsState: { [key: number]: boolean } = {};

    for (let i = 0; i < 10; i++) {
      starsState[i] = false;
    }
    setStars(starsState);
  };

  const handleStarToggle = (index: number) => {
    setStars((prevStars) => ({
      ...prevStars,
      [index]: !prevStars[index],
    }));
  };
  const createCompanyUrl = (pipeline: any): string => {
    if (!pipeline.company?.company_id) return "#";
    return `/companies/${pipeline.company.company_id}`;
  };
  const createContactUrl = (pipeline: any): string => {
    if (!pipeline.primary_contact?.contact_id) return "#";
    return `/contacts/${pipeline.primary_contact.contact_id}`;
  };
  const handleStageUpdate = async (stageId: number | null) => {
    if (!pipeline?.pipeline_id || !selectedTenantId) return;

    setUpdatingStage(true);
    setUpdateMessage(null);

    try {
      const response = await axios.patch(
        `${API_BASE_URL}/pipeline/${pipeline.pipeline_id}/`,
        {
          lifecycle_type_stage_id: stageId,
          tenant_id: selectedTenantId,
        },
        {
          headers: getAuthHeaders(),
        }
      );

      const refreshResponse = await axios.get(
        `${API_BASE_URL}/lookup/pipeline/?pipeline_id=${pipeline.pipeline_id}&tenant_id=${selectedTenantId}`,
        {
          headers: getAuthHeaders(),
        }
      );
      const updatedPipelineData = refreshResponse.data;
      const transformedPipeline =
        transformLookupPipelineToPipeline(updatedPipelineData);

      setPipeline(transformedPipeline);
      setUpdateMessage("Pipeline stage updated successfully!");

      setActivitiesRefreshTrigger((prev) => prev + 1);

      setTimeout(() => setUpdateMessage(null), 3000);
    } catch (error) {
      console.error("Error updating pipeline stage:", error);
      setUpdateMessage("Failed to update pipeline stage");

      setTimeout(() => setUpdateMessage(null), 3000);
    } finally {
      setUpdatingStage(false);
    }
  };
  const handlePriorityUpdate = async (priority: string) => {
    if (!pipeline?.pipeline_id || !selectedTenantId) return;

    setUpdatingPriority(true);
    setUpdateMessage(null);

    try {
      const response = await axios.patch(
        `${API_BASE_URL}/pipeline/${pipeline.pipeline_id}/`,
        {
          priority: priority,
          tenant_id: selectedTenantId,
        },
        {
          headers: getAuthHeaders(),
        }
      );

      const refreshResponse = await axios.get(
        `${API_BASE_URL}/lookup/pipeline/?pipeline_id=${pipeline.pipeline_id}&tenant_id=${selectedTenantId}`,
        {
          headers: getAuthHeaders(),
        }
      );
      const updatedPipelineData = refreshResponse.data;
      const transformedPipeline =
        transformLookupPipelineToPipeline(updatedPipelineData);

      setPipeline(transformedPipeline);
      setUpdateMessage("Pipeline priority updated successfully!");

      setActivitiesRefreshTrigger((prev) => prev + 1);

      setTimeout(() => setUpdateMessage(null), 3000);
    } catch (error) {
      console.error("Error updating pipeline priority:", error);
      setUpdateMessage("Failed to update pipeline priority");

      setTimeout(() => setUpdateMessage(null), 3000);
    } finally {
      setUpdatingPriority(false);
    }
  };

  const handleDeletePipeline = async () => {
    if (!pipeline?.pipeline_id || isDeleting) return;

    setIsDeleting(true);
    setDeleteError("");

    try {
      await PipelineService.deletePipeline(pipeline.pipeline_id);

      setOpenModal(false);

      setShowDeleteLoader(true);

      setTimeout(() => {
        setShowDeleteLoader(false);
        navigate(route.pipelines);
      }, 1500);
    } catch (error: any) {
      console.error("Error deleting pipeline:", error);
      setDeleteError(
        error.response?.data?.message ||
        "Failed to delete pipeline. Please try again."
      );
      setIsDeleting(false);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteError("");
    setOpenModal(false);
  };

  const handleMarkAsActive = async () => {
    if (!pipeline?.pipeline_id || !selectedTenantId) return;

    setUpdatingStage(true);
    setUpdateMessage(null);

    try {
      const response = await axios.patch(
        `${API_BASE_URL}/pipeline/${pipeline.pipeline_id}/`,
        {
          is_archive: false,
          tenant_id: selectedTenantId,
        },
        {
          headers: getAuthHeaders(),
        }
      );

      const refreshResponse = await axios.get(
        `${API_BASE_URL}/lookup/pipeline/?pipeline_id=${pipeline.pipeline_id}&tenant_id=${selectedTenantId}`,
        {
          headers: getAuthHeaders(),
        }
      );

      const updatedPipelineData = refreshResponse.data;
      const transformedPipeline =
        transformLookupPipelineToPipeline(updatedPipelineData);

      setPipeline(transformedPipeline);
      setUpdateMessage("Pipeline marked as active successfully!");

      setActivitiesRefreshTrigger((prev) => prev + 1);

      setTimeout(() => setUpdateMessage(null), 3000);
    } catch (error) {
      console.error("Error marking pipeline as active:", error);
      setUpdateMessage("Failed to mark pipeline as active");

      setTimeout(() => setUpdateMessage(null), 3000);
    } finally {
      setUpdatingStage(false);
    }
  };

  const handleMarkAsArchive = async () => {
    if (!pipeline?.pipeline_id || !selectedTenantId) return;

    setUpdatingStage(true);
    setUpdateMessage(null);

    try {
      const response = await axios.patch(
        `${API_BASE_URL}/pipeline/${pipeline.pipeline_id}/`,
        {
          is_archive: true,
          tenant_id: selectedTenantId,
        },
        {
          headers: getAuthHeaders(),
        }
      );

      const refreshResponse = await axios.get(
        `${API_BASE_URL}/lookup/pipeline/?pipeline_id=${pipeline.pipeline_id}&tenant_id=${selectedTenantId}`,
        {
          headers: getAuthHeaders(),
        }
      );

      const updatedPipelineData = refreshResponse.data;
      const transformedPipeline =
        transformLookupPipelineToPipeline(updatedPipelineData);

      setPipeline(transformedPipeline);
      setUpdateMessage("Pipeline marked as archived successfully!");

      setActivitiesRefreshTrigger((prev) => prev + 1);

      setTimeout(() => setUpdateMessage(null), 3000);
    } catch (error) {
      console.error("Error marking pipeline as archived:", error);
      setUpdateMessage("Failed to mark pipeline as archived");

      setTimeout(() => setUpdateMessage(null), 3000);
    } finally {
      setUpdatingStage(false);
    }
  };

  const handleSendEmail = () => {
    setComposeOpenCounter((prev) => prev + 1);
    setIsComposeEmailOpen(true);
  };

  const handleCloseComposeEmail = () => {
    setIsComposeEmailOpen(false);
  };

  const handleMinimizeComposeEmail = () => {
    setIsComposeEmailOpen(false);
  };

  const getPrimaryEmail = () => {
    if (pipeline?.primary_contact?.primary_email) {
      return pipeline.primary_contact.primary_email;
    }
    return "";
  };

  const isEmailEnabled =
    !emailProvidersLoading && hasConnectedProviders && getPrimaryEmail() !== "";

  const getEmailDisabledReason = () => {
    if (emailProvidersLoading) return "Checking email integration...";
    if (!hasConnectedProviders) return "Email is not integrated";
    if (!pipeline?.primary_contact) return "No contact attached to this pipeline";
    if (!getPrimaryEmail()) return "Attached contact has no email address";
    return "Email is not available";
  };

  const handleRefreshData = async () => {
    if (!id || !selectedTenantId) return;

    try {
      const response = await axios.get(
        `${API_BASE_URL}/lookup/pipeline/?pipeline_id=${id}&tenant_id=${selectedTenantId}`,
        {
          headers: getAuthHeaders(),
        }
      );

      const pipelineData = response.data;
      const transformedPipeline =
        transformLookupPipelineToPipeline(pipelineData);

      setPipeline(transformedPipeline);
      setActivitiesRefreshTrigger((prev) => prev + 1);
    } catch (error) {
      console.error("Error refreshing pipeline data:", error);
    }
  };

  const handleEditSubmit = async (formData: Partial<PipelineRequest>) => {
    if (!pipeline?.pipeline_id || isUpdating) return;

    setIsUpdating(true);
    setEditError("");

    try {
      const updatedPipeline = await PipelineService.updatePipeline(
        pipeline.pipeline_id,
        formData
      );

      setPipeline(updatedPipeline);

      setActivitiesRefreshTrigger((prev) => prev + 1);

      closeOffcanvas("offcanvas_edit_pipeline");

      setTimeout(() => {
        showSuccessAlert(
          `Pipeline "${updatedPipeline.title}" updated successfully!`
        );
      }, 500);
    } catch (error: any) {
      console.error("Error updating pipeline:", error);
      setEditError(getApiErrorMessage(error, "Failed to update pipeline. Please try again."));
      showErrorAlert(getApiErrorMessage(error, "Failed to update pipeline. Please try again."));
      throw error;
    } finally {
      setIsUpdating(false);
    }
  };

  const closeOffcanvas = (offcanvasId: string) => {
    const modal = document.getElementById(offcanvasId);
    if (modal) {
      const closeButton = modal.querySelector(
        '[data-bs-dismiss="offcanvas"]'
      ) as HTMLElement;
      if (closeButton) {
        closeButton.click();
      } else {
        const bsOffcanvas = (window as any).bootstrap?.Offcanvas?.getInstance(
          modal
        );
        if (bsOffcanvas) {
          bsOffcanvas.hide();
        }
      }
    }
  };

  const DeletePreloader = () => {
    return (
      <div
        className="preloader"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div className="loader"></div>
        <p className="mt-3 text-muted">
          Pipeline deleted successfully. Redirecting...
        </p>
      </div>
    );
  };

  const sortbydata = [
    { value: "Sort By Date", label: "Sort By Date" },
    { value: "Ascending", label: "Ascending" },
    { value: "Descending", label: "Descending" },
  ];

  const dealsopen = [
    { value: "choose", label: "Choose" },
    { value: "collins", label: "Collins" },
    { value: "konopelski", label: "Konopelski" },
    { value: "adams", label: "Adams" },
    { value: "schumm", label: "Schumm" },
    { value: "wisozk", label: "Wisozk" },
  ];

  const priorityOptions = [
    {
      value: "High",
      label: "High",
      icon: (
        <i className="ti ti-square-rounded-filled me-1 text-danger circle" />
      ),
    },
    {
      value: "Medium",
      label: "Medium",
      icon: (
        <i className="ti ti-square-rounded-filled me-1 text-secondary circle" />
      ),
    },
    {
      value: "Low",
      label: "Low",
      icon: <i className="ti ti-square-rounded-filled me-1 text-info circle" />,
    },
  ];

  const columns = [
    {
      title: "",
      dataIndex: "",
      render: (text: string, record: any, index: number) => (
        <div
          className={`set-star rating-select ${stars[index] ? "filled" : ""}`}
          onClick={() => handleStarToggle(index)}
        >
          <i className="fa fa-star"></i>
        </div>
      ),
    },
  ];

  useEffect(() => {
    initializeStarsState();
  }, []);

  useEffect(() => {
    const editOffcanvas = document.getElementById("offcanvas_edit_pipeline");

    const handleHidden = () => {
      setIsEditPipelineOpen(false);
    };

    if (editOffcanvas) {
      editOffcanvas.addEventListener("hidden.bs.offcanvas", handleHidden);
    }

    return () => {
      if (editOffcanvas) {
        editOffcanvas.removeEventListener("hidden.bs.offcanvas", handleHidden);
      }
    };
  }, []);

  useEffect(() => {
    const fetchPipeline = async () => {
      if (!id) {
        setError(`${getLifecycleTypeName("PIPELINE")} ID not provided`);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setStagesLoading(true);

        const tenantId = localStorage.getItem("selectedTenantId");
        if (!tenantId) {
          setError("No tenant ID found");
          setLoading(false);
          setStagesLoading(false);
          return;
        }

        const response = await axios.get(
          `${API_BASE_URL}/lookup/pipeline/?pipeline_id=${id}&tenant_id=${tenantId}`,
          {
            headers: getAuthHeaders(),
          }
        );

        const pipelineData = response.data;
        const transformedPipeline =
          transformLookupPipelineToPipeline(pipelineData);

        setPipeline(transformedPipeline);

        if (
          pipelineData.lifecycle_type_stage &&
          Array.isArray(pipelineData.lifecycle_type_stage)
        ) {
          const sortedStages = pipelineData.lifecycle_type_stage.sort(
            (a: any, b: any) => a.stage_order - b.stage_order
          );
          setLifecycleStages(sortedStages);
        }

        setStagesLoading(false);
        setLoading(false);
      } catch (err: any) {
        console.error("Error fetching pipeline details:", err);

        if (err?.response?.status === 404) {
          navigate(route.pipelines);
          return;
        }

        setError("Failed to fetch pipeline details");
        setLoading(false);
        setStagesLoading(false);
      }
    };

    fetchPipeline();
  }, [id]);

  const refreshPipelineData = async () => {
    const pipelineId = id || pipeline?.pipeline_id;
    const tenantId = selectedTenantId || localStorage.getItem("selectedTenantId");
    if (!pipelineId || !tenantId) return;

    try {
      const response = await axios.get(
        `${API_BASE_URL}/lookup/pipeline/?pipeline_id=${pipelineId}&tenant_id=${tenantId}`,
        {
          headers: getAuthHeaders(),
        }
      );

      const pipelineData = response.data;
      const transformedPipeline =
        transformLookupPipelineToPipeline(pipelineData);

      setPipeline(transformedPipeline);
    } catch (err: any) {
      console.error("Error refreshing pipeline details:", err);
    }
  };
  useEffect(() => {
    if (contextLifecycleStages.length > 0 && lifecycleStages.length === 0) {
      setLifecycleStages(contextLifecycleStages);
      setStagesLoading(false);
    }
  }, [contextLifecycleStages, lifecycleStages]);
  if (loading) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-sm-4">
                    <h4 className="page-title">
                      {getLifecycleTypeName("PIPELINE")} Overview
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: "400px" }}
                  >
                    <div className="text-center">
                      <div
                        className="spinner-border text-primary mb-3"
                        role="status"
                        style={{ width: "3rem", height: "3rem" }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <h5 className="text-muted">
                        Loading {getLifecycleTypeName("PIPELINE")} details...
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error || !pipeline) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-sm-4">
                    <h4 className="page-title">
                      {getLifecycleTypeName("PIPELINE")} Overview
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="alert alert-danger">
                {error || `${getLifecycleTypeName("PIPELINE")} not found`}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const isStageActive = (stageId: number): boolean => {
    if (!pipeline.lifecycle_type_stage?.lifecycle_type_stage_id) return false;

    const currentStageId =
      pipeline.lifecycle_type_stage.lifecycle_type_stage_id;
    const currentStage = lifecycleStages.find(
      (stage) => stage.lifecycle_type_stage_id === currentStageId
    );
    const checkStage = lifecycleStages.find(
      (stage) => stage.lifecycle_type_stage_id === stageId
    );

    if (!currentStage || !checkStage) return false;

    return checkStage.stage_order <= currentStage.stage_order;
  };
  return (
    <>
      {/* Show delete loader overlay */}
      {showDeleteLoader && <DeletePreloader />}
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {" "}
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-sm-4">
                    <h4 className="page-title">
                      {getLifecycleTypeName("PIPELINE")} Overview
                    </h4>
                  </div>
                  <div className="col-sm-8 text-sm-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              {/* Success/Error Message */}
              {updateMessage && (
                <div className="row">
                  <div className="col-md-12">
                    <div
                      className={`alert ${updateMessage.includes("successfully")
                        ? "alert-success"
                        : "alert-danger"
                        } alert-dismissible fade show`}
                      role="alert"
                    >
                      {updateMessage}
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setUpdateMessage(null)}
                      ></button>
                    </div>
                  </div>
                </div>
              )}
              {/* /Page Header */}
            </div>
          </div>
          <>
            <div className="row">
              <div className="col-md-12">
                {/* Pipeline User */}
                <div className="contact-head">
                  <div className="row align-items-center">
                    <div className="col-sm-6">
                      {" "}
                      <ul className="contact-breadcrumb">
                        <li>
                          <Link to={route.pipelines}>
                            <i className="ti ti-arrow-narrow-left" />
                            {getLifecycleTypeName("PIPELINE")}
                          </Link>
                        </li>
                        <li>
                          {pipeline.title && pipeline.title.length > 70 ? (
                            <Tooltip title={pipeline.title} placement="top" arrow>
                              <p className="mb-1" style={{ cursor: "default" }}>
                                {`${pipeline.title.substring(0, 70)}...`}
                              </p>
                            </Tooltip>
                          ) : (
                            <p className="mb-1">{pipeline.title}</p>
                          )}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card" style={{ position: 'relative' }}>
                  {pipeline.is_archive && (
                    <div
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '150px',
                        height: '150px',
                        overflow: 'hidden',
                        zIndex: 10,
                        pointerEvents: 'none',
                      }}
                    >
                      <div
                        style={{
                          position: 'absolute',
                          top: '20px',
                          left: '-53px',
                          backgroundColor: '#dc3545',
                          color: 'white',
                          padding: '8px 40px',
                          fontSize: '10px',
                          fontWeight: 'bold',
                          textTransform: 'uppercase',
                          transform: 'rotate(-45deg)',
                          boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
                          textAlign: 'center',
                          width: '150px',
                        }}
                      >
                        Archived
                      </div>
                    </div>
                  )}
                  <div className="card-body pb-2 crm-detail-head">
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                      <div className="d-flex align-items-center mb-2">
                        <div
                          className="avatar avatar-xl me-3 flex-shrink-0 border p-2 bg-light"
                          style={{ borderRadius: "50%" }}
                        >
                          <i
                            className="ti ti-timeline-event-exclamation"
                            style={{ color: "#824eeb", fontSize: "3rem" }}
                          />
                        </div>
                        <div>
                          <div className="d-flex align-items-center flex-wrap gap-2">
                            {pipeline.title && pipeline.title.length > 30 ? (
                              <Tooltip title={pipeline.title} placement="top" arrow>
                                <h3 className="mb-1" style={{ cursor: "default" }}>
                                  {`${pipeline.title.substring(0, 30)}...`}
                                </h3>
                              </Tooltip>
                            ) : (
                              <h3 className="mb-1">{pipeline.title}</h3>
                            )}
                            {pipeline.lifecycle_status_reason && (
                              <Tooltip title={pipeline.lifecycle_status_reason?.reason_name} placement="top" arrow>
                                <span
                                  className={`badge d-inline-flex align-items-center mb-1 ${pipeline.lifecycle_status_reason?.lifecycle_status_reason_category_key === "WON" ? "bg-success" : "bg-secondary"}`}
                                  style={{ cursor: "default" }}
                                >
                                  <i className={`fa ${pipeline.lifecycle_status_reason?.lifecycle_status_reason_category_key === "WON" ? "fa-trophy" : "fa-thumbs-down"} me-1`} />
                                  {pipeline.lifecycle_status_reason?.lifecycle_status_reason_category_key === "WON" ? "Won" : "Lost"}
                                </span>
                              </Tooltip>
                            )}
                          </div>
                          <p className="mb-1">
                            <i className="ti ti-building me-1" />
                            {pipeline.company?.company_name || "No Company"}
                          </p>
                        </div>
                      </div>
                      <div className="contacts-action">
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          <div className="mb-2">
                            <Select
                              options={lifecycleStages.map((stage) => ({
                                value: stage.lifecycle_type_stage_id,
                                label: stage.stage_name,
                              }))}
                              value={
                                lifecycleStages.find(
                                  (stage) =>
                                    stage.lifecycle_type_stage_id ===
                                    pipeline.lifecycle_type_stage
                                      ?.lifecycle_type_stage_id
                                )
                                  ? {
                                    value:
                                      pipeline.lifecycle_type_stage
                                        ?.lifecycle_type_stage_id,
                                    label:
                                      pipeline.lifecycle_type_stage
                                        ?.stage_name,
                                  }
                                  : null
                              }
                              onChange={(option) =>
                                handleStageUpdate(option?.value || null)
                              }
                              placeholder="Select stage"
                              isClearable={false}
                              isLoading={updatingStage}
                              isDisabled={updatingStage}
                              className="min-w-200"
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  minWidth: "200px",
                                  backgroundColor: "#28a745",
                                  borderColor: "#28a745",
                                  color: "white",
                                }),
                                singleValue: (provided) => ({
                                  ...provided,
                                  color: "white",
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  color: "rgba(255, 255, 255, 0.8)",
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999,
                                }),
                              }}
                            />
                          </div>
                          {isEmailEnabled ? (
                            <button
                              className="btn btn-secondary d-flex align-items-center mb-2"
                              onClick={handleSendEmail}
                              title="Send Email"
                            >
                              <i className="ti ti-mail me-2" />
                              Send Email
                            </button>
                          ) : (
                            <Tooltip title={getEmailDisabledReason()} placement="top" arrow>
                              <span
                                className="btn btn-secondary d-flex align-items-center mb-2"
                                style={{ cursor: "not-allowed", opacity: 0.5 }}
                              >
                                <i className="ti ti-mail me-2" />
                                Send Email
                              </span>
                            </Tooltip>
                          )}
                          <Link
                            to="#"
                            className="btn-icon d-flex align-items-center justify-content-center mb-2"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvas_edit_pipeline"
                            title={`Edit ${getLifecycleTypeName("PIPELINE")}`}
                            onClick={() => setIsEditPipelineOpen(true)}
                          >
                            <i className="ti ti-edit-circle fs-16" />
                          </Link>
                          <Link
                            className="btn-icon d-flex align-items-center justify-content-center mb-2"
                            to="#"
                            onClick={(e) => { e.preventDefault(); setShowSalesActivityModal(true); }}
                            title="Log Activity"
                          >
                            <i className="ti ti-clipboard-list fs-16" />
                          </Link>
                          <div className="dropdown">
                            <Link
                              to="#"
                              className="btn-icon d-flex align-items-center justify-content-center mb-2"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              title="More Actions"
                            >
                              <i className="ti ti-dots-vertical fs-16" />
                            </Link>
                            <div className="dropdown-menu dropdown-menu-end dropup" style={{ minWidth: "220px" }}>
                              {pipeline.is_archive ? (
                                <Link
                                  className="dropdown-item d-flex align-items-center"
                                  to="#"
                                  onClick={() => handleMarkAsActive()}
                                >
                                  <i className="ti ti-check text-success me-2" />
                                  Mark as Active
                                </Link>
                              ) : (
                                <Link
                                  className="dropdown-item d-flex align-items-center"
                                  to="#"
                                  onClick={() => handleMarkAsArchive()}
                                >
                                  <i className="ti ti-archive-off text-warning me-2" />
                                  Mark as Archive
                                </Link>
                              )}
                              <Link
                                className="dropdown-item d-flex align-items-center"
                                to="#"
                                onClick={(e) => { e.preventDefault(); setShowMarkStatusModal(true); }}
                              >
                                <i className="ti ti-trophy text-info me-2" />
                                Mark as Lost/Won
                              </Link>

                              <Link
                                className="dropdown-item d-flex align-items-center"
                                to="#"
                                onClick={() => setOpenModal(true)}
                              >
                                <i className="ti ti-trash text-danger me-2" />
                                Delete
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Pipeline User */}
              </div>
              {/* Pipeline Sidebar */}
              <div className="col-xl-3 theiaStickySidebar crm-detail-sidebar">
                <div className="card">
                  <div className="card-body p-3">
                    <h6 className="mb-3 fw-semibold">
                      {getLifecycleTypeName("PIPELINE")} Information
                    </h6>
                    <ul>
                      <li className="row mb-3">
                        <span className="col-6">Estimated Value</span>
                        <span className="col-6">
                          {pipeline.estimated_value
                            ? `${pipeline.currency_code || "USD"
                            } ${Number(pipeline.estimated_value || 0).toFixed(4)}`
                            : "Not specified"}
                        </span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Source</span>
                        <span className="col-6">
                          {pipeline.lifecycle_source?.lifecycle_source_display_name || (pipeline as any)?.source || "Not specified"}
                        </span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Lifecycle Stage</span>
                        <span className="col-6">
                          <span
                            className={`badge ${getStageColorByOrder(
                              lifecycleStages.find(
                                (stage) =>
                                  stage.lifecycle_type_stage_id ===
                                  pipeline.lifecycle_type_stage
                                    ?.lifecycle_type_stage_id
                              )?.stage_order || 1
                            )}`}
                          >
                            {pipeline.lifecycle_type_stage?.stage_name ||
                              "Not Set"}
                          </span>
                        </span>
                      </li>
                    </ul>
                    <CustomFieldDisplay
                      customFields={(pipeline as any)?.custom_fields}
                      showTitle={true}
                    />
                    <h6 className="mb-3 fw-semibold">Assigned Team</h6>
                    {pipeline.assigned_team && (
                      <div className="d-flex align-items-center mb-3">
                        <div
                          className="avatar avatar-md me-2 d-flex align-items-center justify-content-center bg-light"
                          style={{ width: 40, height: 40, borderRadius: "50%" }}
                        >
                          <i className="ti ti-users fs-24 text-primary" />
                        </div>
                        <div>
                          <div>
                            {pipeline.assigned_team.team_name ||
                              pipeline.assigned_team.name ||
                              "Not Assigned"}
                          </div>
                        </div>
                      </div>
                    )}
                    <hr />
                    <h6 className="mb-3 fw-semibold">Assigned User</h6>
                    <div className="d-flex align-items-center mb-3">
                      <span
                        className="avatar avatar-sm border rounded-circle p-1 me-2"
                        style={{ borderRadius: "50%" }}
                      >
                        <img
                          src={pipeline.assigned_user?.avatar_url || male}
                          alt="Image"
                          style={{
                            width: "25px",
                            height: "25px",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                      </span>
                      <p>
                        {pipeline.assigned_user?.full_name || "Not Assigned"}
                      </p>
                    </div>
                    <hr />
                    <h6 className="mb-3 fw-semibold">Company</h6>
                    <div className="d-flex align-items-center">
                      <span
                        className="avatar avatar-sm border rounded-circle p-1 me-2"
                        style={{ borderRadius: "50%" }}
                      >
                        <img
                          src={pipeline.company?.avatar_url || company}
                          alt="Image"
                          style={{
                            borderRadius: "50%",
                          }}
                        />
                      </span>

                      <p
                        style={{
                          textDecoration: "underline",
                          cursor: "pointer",
                          fontSize: "16px",
                        }}
                      >
                        <Link to={createCompanyUrl(pipeline)} target="_blank">
                          {pipeline.company?.company_name || "Not specified"}
                        </Link>
                      </p>
                    </div>
                    <hr />
                    <h6 className="mb-3 fw-semibold">Contact</h6>
                    <div className="d-flex align-items-center mb-3">
                      <span
                        className="avatar avatar-sm border rounded-circle p-1 me-2"
                        style={{ borderRadius: "50%" }}
                      >
                        <img
                          src={pipeline.primary_contact?.avatar_url || male}
                          alt="Image"
                          style={{
                            width: "25px",
                            height: "25px",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                      </span>
                      <Link
                        to={createContactUrl(pipeline)}
                        target="_blank"
                        style={{ textDecoration: "underline" }}
                      >
                        {pipeline.primary_contact?.full_name || "Unassigned"}
                      </Link>
                    </div>
                    <ul>
                      <li className="row mb-3">
                        <span className="col-6">Primary Phone</span>
                        <span className="col-6">
                          {pipeline.primary_contact?.primary_phone ||
                            "Not specified"}
                        </span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Primary Email</span>
                        <span className="col-6">
                          {pipeline.primary_contact?.primary_email ||
                            "Not specified"}
                        </span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Job Title</span>
                        <span className="col-6">
                          {pipeline.primary_contact?.job_title ||
                            "Not specified"}
                        </span>
                      </li>
                    </ul>
                    <hr />
                    <h6 className="mb-3 fw-semibold">Priority</h6>
                    <div className="priority-info">
                      <Select
                        options={priorityOptions}
                        value={
                          priorityOptions.find(
                            (option) => option.value === pipeline.priority
                          ) || null
                        }
                        onChange={(option) =>
                          handlePriorityUpdate(option?.value || "")
                        }
                        placeholder="Select priority"
                        isClearable={false}
                        isLoading={updatingPriority}
                        isDisabled={updatingPriority}
                        className="min-w-150"
                        formatOptionLabel={(option: any) => (
                          <div className="d-flex align-items-center">
                            {option.icon}
                            <span>{option.label}</span>
                          </div>
                        )}
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            minWidth: "150px",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                        }}
                      />
                    </div>
                    <hr />
                    <h6 className="mb-3 fw-semibold">
                      Related {getLifecycleTypeName("LEAD")}
                    </h6>{" "}
                    <div className="d-flex align-items-center mb-3">
                      <div
                        className="avatar avatar-md flex-shrink-0 border p-2 bg-light"
                        style={{ borderRadius: "50%" }}
                      >
                        <i
                          className="ti ti-chart-arcs mt-2"
                          style={{ color: "#824eeb", fontSize: "1.5rem" }}
                        />
                      </div>
                      <div>
                        {pipeline.realted_lead ? (
                          <Link
                            to={`/leads/${pipeline.realted_lead.lead_id}`}
                            target="_blank"
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                              fontSize: "16px",
                            }}
                          >
                            {pipeline.realted_lead.title && pipeline.realted_lead.title.length > 50 ? (
                              <Tooltip title={pipeline.realted_lead.title} placement="top" arrow>
                                <span className="d-block mb-1" style={{ cursor: "pointer" }}>
                                  {`${pipeline.realted_lead.title.substring(0, 50)}...`}
                                </span>
                              </Tooltip>
                            ) : (
                              <span className="d-block mb-1">{pipeline.realted_lead.title}</span>
                            )}
                          </Link>
                        ) : (
                          <p>No Related {getLifecycleTypeName("LEAD")}</p>
                        )}
                      </div>
                    </div>
                    <hr />

                    {/* Tags Section */}

                    <>
                      <h6 className="mb-3 fw-semibold">Tags</h6>
                      <ul className="social-info">
                        <li style={{ padding: '5px' }}>
                          {
                            pipeline?.tags?.insert && Array.isArray(pipeline.tags.insert) && pipeline.tags.insert.length > 0 ? (
                              pipeline.tags.insert.map((tag: any, index: number) => (
                                <span key={index}
                                  className="badge me-1"
                                  style={{
                                    backgroundColor: '#824EEB',
                                    color: 'white'
                                  }}>
                                  {typeof tag === 'object' ? tag.entity_tag_name : tag}
                                </span>
                              ))
                            ) : (
                              <span className="text-muted">No Tags Assigned</span>
                            )
                          }
                        </li>
                      </ul>
                    </>
                    <hr />

                    <ul>
                      <li className="row mb-3">
                        <span className="col-6">Created At</span>
                        <span className="col-6">
                          {formatCustomDateTime(pipeline.created_datetime)}
                        </span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Created By</span>
                        <span className="col-6 d-flex align-items-center">
                          <span className="avatar avatar-xs me-1">
                            <img
                              src={pipeline.created_by?.avatar_url || male}
                              alt="Image"
                              style={{
                                width: "25px",
                                height: "20px",
                                borderRadius: "50%",
                              }}
                            />
                          </span>
                          <span>
                            {pipeline.created_by
                              ? `${pipeline.created_by.full_name}`
                              : "No User Found"}
                          </span>
                        </span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Last Modified</span>
                        <span className="col-6">
                          {formatCustomDateTime(pipeline.updated_datetime)}
                        </span>
                      </li>
                      <li className="row mb-0">
                        <span className="col-6">Modified By</span>
                        <span className="col-6 d-flex align-items-center">
                          <span className="avatar avatar-xs me-1">
                            <img
                              src={pipeline.updated_by?.avatar_url || male}
                              alt="Image"
                              style={{
                                width: "25px",
                                height: "20px",
                                borderRadius: "50%",
                              }}
                            />
                          </span>
                          {pipeline.updated_by
                            ? `${pipeline.updated_by.full_name}`
                            : "No User Found"}
                        </span>
                      </li>
                    </ul>

                  </div>
                </div>
              </div>
              {/* /Pipeline Sidebar */}
              {/* Pipeline Details */}
              <div className="col-xl-9">
                <div className="card mb-3">
                  <div className="card-body pb-0">
                    <h4 className="fw-semibold mb-3">
                      {getLifecycleTypeName("PIPELINE")} LifeCycle Status
                    </h4>
                    {stagesLoading ? (
                      <div className="d-flex align-items-center justify-content-center py-3">
                        <div
                          className="spinner-border spinner-border-sm text-primary me-2"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <span className="text-muted">
                          Loading {getLifecycleTypeName("PIPELINE")} stages...
                        </span>
                      </div>
                    ) : lifecycleStages.length > 0 ? (
                      <div className="pipeline-list">
                        <ul>
                          {lifecycleStages.map((stage) => (
                            <li key={stage.lifecycle_type_stage_id}>
                              <Link
                                to="#"
                                className={
                                  isStageActive(stage.lifecycle_type_stage_id)
                                    ? getStageColorByOrder(stage.stage_order)
                                    : "bg-gray"
                                }
                                style={{
                                  pointerEvents: isStageActive(
                                    stage.lifecycle_type_stage_id
                                  )
                                    ? "auto"
                                    : "none",
                                  color: isStageActive(
                                    stage.lifecycle_type_stage_id
                                  )
                                    ? ""
                                    : "#fff",
                                }}
                              >
                                {stage.stage_name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ) : (
                      <div className="text-center py-3">
                        <span className="text-muted">
                          No {getLifecycleTypeName("PIPELINE")} stages found
                        </span>
                      </div>
                    )}
                    <Tabs showProductsServicesTab={true} showChatTab={true} />
                  </div>
                </div>
                {/* Tab Content */}
                <div className="tab-content pt-0">
                  {/* Activities */}
                  <Activities
                    tenant_id={selectedTenantId}
                    related_entity_id={pipeline?.pipeline_id}
                    refreshTrigger={activitiesRefreshTrigger}
                    related_entity_name="pipeline"
                    crm_entity_id={pipeline?.crm_entity_id}
                  />
                  {/* /Activities */}

                  <Notes
                    tenant_id={selectedTenantId}
                    related_entity_id={pipeline?.pipeline_id}
                    related_entity_name="pipeline"
                    refreshTrigger={activitiesRefreshTrigger}
                    onActivityUpdate={() =>
                      setActivitiesRefreshTrigger((prev) => prev + 1)
                    }
                  />

                  <Files
                    tenant_id={selectedTenantId}
                    related_entity_id={pipeline?.pipeline_id}
                    related_entity_name="pipeline"
                    refreshTrigger={activitiesRefreshTrigger}
                  />

                  <Tasks
                    tenant_id={selectedTenantId}
                    related_entity_id={pipeline?.pipeline_id}
                    related_entity_name="pipeline"
                    refreshTrigger={activitiesRefreshTrigger}
                    onActivityUpdate={() =>
                      setActivitiesRefreshTrigger((prev) => prev + 1)
                    }
                  />

                  <ProductsServices
                    tenant_id={selectedTenantId}
                    related_entity_id={pipeline?.pipeline_id}
                    related_entity_name="pipeline"
                    onActivityUpdate={() =>
                      setActivitiesRefreshTrigger((prev) => prev + 1)
                    }
                    onEntityUpdate={refreshPipelineData}
                    currencyCode={pipeline?.currency_code || undefined}
                  />

                  <Email
                    contactIds={
                      pipeline?.primary_contact?.contact_id
                        ? [pipeline.primary_contact.contact_id]
                        : []
                    }
                  />

                  <Chat
                    tenant_id={selectedTenantId}
                    contact_id={pipeline?.primary_contact?.contact_id}
                    isContactPage={true}
                    lifecycleName="pipeline"
                  />
                </div>
              </div>
              {/* /Pipeline Details */}
            </div>
          </>
        </div>
      </div>
      {/* Delete Confirmation Modal */}
      <Modal show={openModal} onHide={handleDeleteCancel} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete {getLifecycleTypeName("PIPELINE")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you want to delete the pipeline "{pipeline.title}"?
          </p>
          <p className="text-muted small">This action cannot be undone.</p>
          {deleteError && (
            <div className="alert alert-danger mt-2">{deleteError}</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleDeleteCancel}
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleDeletePipeline}
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Deleting...
              </>
            ) : (
              `Delete ${getLifecycleTypeName("PIPELINE")}`
            )}
          </button>
        </Modal.Footer>
      </Modal>{" "}
      {/* Edit Pipeline Offcanvas */}
      <div
        className="offcanvas offcanvas-end"
        id="offcanvas_edit_pipeline"
        style={{ width: "550px" }}

        data-bs-keyboard="false"
      >
        <div className="offcanvas-header border-bottom">
          <h4 className="offcanvas-title">
            Edit {getLifecycleTypeName("PIPELINE")}
          </h4>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
          ></button>
        </div>
        <div className="offcanvas-body">
          {isUpdating && (
            <div className="d-flex justify-content-center align-items-center py-3">
              <div
                className="spinner-border spinner-border-sm text-primary me-2"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
              <span className="text-muted">
                Updating {getLifecycleTypeName("PIPELINE")}...
              </span>
            </div>
          )}
          {editError && (
            <div className="alert alert-danger" role="alert">
              {editError}
            </div>
          )}
          {isEditPipelineOpen && pipeline && !isUpdating && (
            <PipelineForm
              pipeline={pipeline}
              onSubmit={handleEditSubmit}
              onCancel={() => closeOffcanvas("offcanvas_edit_pipeline")}
              isSubmitting={isUpdating}
              onRefreshData={handleRefreshData}
            />
          )}
        </div>
      </div>
      {/* Compose Email Modal */}
      <ComposeEmail
        key={`compose-email-${composeOpenCounter}`}
        isOpen={isComposeEmailOpen}
        onClose={handleCloseComposeEmail}
        onMinimize={handleMinimizeComposeEmail}
        draftData={{
          send_to: getPrimaryEmail(),
          subject: `Re: ${pipeline?.title || "Pipeline"}`,
        }}
        readOnlyRecipient={false}
        crm_entity_id={pipeline?.crm_entity_id}
        record_id={pipeline?.pipeline_id}
      />

      {showMarkStatusModal && pipeline && (
        <MarkStatusModal
          entityType="pipeline"
          entityId={pipeline.pipeline_id!}
          tenantId={Number(selectedTenantId)}
          currentStatusReasonId={pipeline.lifecycle_status_reason?.lifecycle_status_reason_id}
          onClose={() => setShowMarkStatusModal(false)}
          onSuccess={handleMarkStatusSuccess}
        />
      )}

      {showSalesActivityModal && pipeline && (
        <SalesActivityModal
          isVisible={showSalesActivityModal}
          onClose={() => setShowSalesActivityModal(false)}
          crmEntityId={pipeline.crm_entity_id}
          recordId={pipeline.pipeline_id}
          onSuccess={() => setActivitiesRefreshTrigger((prev) => prev + 1)}
        />
      )}
    </>
  );
};

const PipelineDetails = () => {
  const [isEditPipelineOpen, setIsEditPipelineOpen] = useState(false);

  return (
    <PipelineFormDataProvider isMainApiCompleted={true} shouldLoad={isEditPipelineOpen}>
      <PipelineDetailsContent
        isEditPipelineOpen={isEditPipelineOpen}
        setIsEditPipelineOpen={setIsEditPipelineOpen}
      />
    </PipelineFormDataProvider>
  );
};

export default PipelineDetails;
